import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {LogEntry} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

// Define a type for the slice state
export interface UiState {
  logEditor: boolean
  logEditorValue: string
  currentLog: Partial<LogEntry>|null
}

// Define the initial state using that type
const initialState: UiState = {
  logEditor: false,
  logEditorValue: '',
  currentLog: null
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setLogEditor: (state, action: PayloadAction<boolean>) => {
      state.logEditor = action.payload
    },
    setCurrentLog: (state, action: PayloadAction<Partial<LogEntry>>) => {
      state.currentLog = action.payload
    }
  }
})

export const { setLogEditor, setCurrentLog } = uiSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectLogEditor = (state: RootState) => state.ui.logEditor
export const selectCurrentLog = (state: RootState) => state.ui.currentLog

export default uiSlice.reducer